import React, { FC } from 'react';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FormItem, useFiltersLabel, FiltersNameEnum, FilterDrawerType } from '@blocs.filter';
import { FiltersCategoryNameEnum } from '../../shared/types';
import { OtherExperience } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const OtherExperienceCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { isCategoryMatchedSearch } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.otherExperience);

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <OtherExperience
          name={FiltersNameEnum.otherExperience}
          label={filtersLabelOfAudience[FiltersNameEnum.otherExperience]}
        />
      </FormItem>
    )
  );
};

export default OtherExperienceCategory;
